var map_obj;
var geocoder;
var marker;

function initMap() {
	map_obj = new google.maps.Map(document.getElementById('map-container'), {
		center: {lat: 51.92576794358916, lng: 19.843252822408886},
		zoom: 7,
		styles:
/// styl mapy https://snazzymaps.com/style/287520/black-map
[{
        "featureType": "all",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "gamma": 0.01
            },
            {
                "lightness": 20
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "saturation": -31
            },
            {
                "lightness": -33
            },
            {
                "weight": 2
            },
            {
                "gamma": 0.8
            }
        ]
    },
    {
        "featureType": "all",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#050505"
            }
        ]
    },
    {
        "featureType": "administrative.locality",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#fef3f3"
            },
            {
                "weight": "3.01"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#0a0a0a"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "administrative.neighborhood",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#fffbfb"
            },
            {
                "weight": "3.01"
            },
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "landscape",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 30
            },
            {
                "saturation": 30
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "saturation": 20
            }
        ]
    },
    {
        "featureType": "poi.attraction",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 20
            },
            {
                "saturation": -20
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "lightness": 10
            },
            {
                "saturation": -30
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "saturation": 25
            },
            {
                "lightness": 25
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#686868"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "color": "#292929"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#202020"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "simplified"
            },
            {
                "hue": "#0006ff"
            },
            {
                "saturation": "-100"
            },
            {
                "lightness": "13"
            },
            {
                "gamma": "0.00"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#686868"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "visibility": "off"
            },
            {
                "color": "#8d8d8d"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#353535"
            },
            {
                "lightness": "6"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#ffffff"
            },
            {
                "weight": "3.45"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "color": "#686868"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "geometry.stroke",
        "stylers": [
            {
                "lightness": "2"
            },
            {
                "visibility": "on"
            },
            {
                "color": "#999898"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#faf8f8"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry.fill",
        "stylers": [
            {
                "visibility": "on"
            },
            {
                "color": "#000000"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "all",
        "stylers": [
            {
                "lightness": -20
            }
        ]
    }
]
	});

	geocoder = new google.maps.Geocoder();
}

function findAddress(ev) {
	//ev.preventDefault();
	hideMarker();
	$('.search-error').empty().hide();

	var address = $('.form-input--personalize').val();
	if (address.length < 3) {
		$('.search-error').html('Adres jest za krótki').show();
		return;
	}
    $('.map-address').val(address);
	geocoder.geocode({
		address: address
	}, function(results, status) {
		if (status == google.maps.GeocoderStatus.OK) {
			var pos = results[0].geometry.location;
            console.log(pos);
			showMarker(pos);
			map_obj.setCenter(pos);
			map_obj.setZoom(13);
            //console.log(map_obj);
            updateMapShot(map_obj);             
		} else {
			$('.search-error').html('Nie znaleziono miejsca').show();
			return;
		}
	});
}

function updateMapShot(map_obj) {
    var mapWidth = Math.floor($("#personalize-map").width());
    var mapHeight = Math.floor($("#personalize-map").height());
    var mapStatic = "https://maps.googleapis.com/maps/api/staticmap?";
    mapStatic += "size=" + mapWidth + "x" + mapHeight + "&zoom=" + map_obj.zoom + "&center=" + map_obj.center.lat() + "," + map_obj.center.lng() + "&maptype=roadmap" + "&key=AIzaSyDX6zFURuhQ7xmMdHjoQz-E3lq8Z21QSh0";
    // Snazzymaps JSON converter -> http://jsfiddle.net/gaby/s6Dyp/
    mapStatic += "&style=feature:all|element:geometry|color:0xffffff&style=feature:all|element:labels|visibility:off&style=feature:all|element:labels.text.fill|gamma:0.01|lightness:20&style=feature:all|element:labels.text.stroke|saturation:-31|lightness:-33|weight:2|gamma:0.8&style=feature:all|element:labels.icon|visibility:off&style=feature:administrative.locality|element:labels.text.fill|color:0x050505&style=feature:administrative.locality|element:labels.text.stroke|color:0xfef3f3|weight:3.01&style=feature:administrative.neighborhood|element:labels.text.fill|color:0x0a0a0a|visibility:off&style=feature:administrative.neighborhood|element:labels.text.stroke|color:0xfffbfb|weight:3.01|visibility:off&style=feature:landscape|element:geometry|lightness:30|saturation:30&style=feature:poi|element:geometry|saturation:20&style=feature:poi.attraction|element:labels.icon|visibility:off&style=feature:poi.park|element:geometry|lightness:20|saturation:-20&style=feature:road|element:geometry|lightness:10|saturation:-30&style=feature:road|element:geometry.stroke|saturation:25|lightness:25&style=feature:road.highway|element:geometry.fill|visibility:on|color:0x686868&style=feature:road.highway|element:geometry.stroke|color:0x292929&style=feature:road.highway|element:labels.text.fill|visibility:off|color:0x202020&style=feature:road.highway|element:labels.text.stroke|visibility:on|color:0xffffff&style=feature:road.highway|element:labels.icon|visibility:simplified|hue:0x0006ff|saturation:-100|lightness:13|gamma:0.00&style=feature:road.arterial|element:geometry.fill|visibility:on|color:0x686868&style=feature:road.arterial|element:geometry.stroke|visibility:off|color:0x8d8d8d&style=feature:road.arterial|element:labels.text.fill|visibility:on|color:0x353535|lightness:6&style=feature:road.arterial|element:labels.text.stroke|visibility:on|color:0xffffff|weight:3.45&style=feature:road.local|element:geometry.fill|color:0x686868&style=feature:road.local|element:geometry.stroke|lightness:2|visibility:on|color:0x999898&style=feature:road.local|element:labels.text.fill|color:0x000000&style=feature:road.local|element:labels.text.stroke|color:0xfaf8f8&style=feature:transit.line|element:geometry.fill|visibility:on|color:0x000000&style=feature:water|element:all|lightness:-20&style=element:labels|visibility:off";
    $('.map-shot').attr('value', mapStatic);
    $('.map-shot-test').attr('src', mapStatic);
}

function showMarker(location) {
	if (marker) {
		marker.setPosition(location);
	} else {
		marker = new google.maps.Marker({
			position: location,
			icon: 'https://cdn.shopify.com/s/files/1/0590/5658/6948/files/marker.png',
			map: map_obj
		});
	}
}
function hideMarker() {
	if (marker) {
		marker.setMap(null);
		marker = null;
	}
}

function mapResize() {
	var width = $('.map').width();
	$('.map').height(width);
    updateMapShot(map_obj);
}

// function convertasbinaryimage() {
//     html2canvas(document.getElementById("personalize-map"), {useCORS: true}).then(function(canvas) {
//         var img = canvas.toDataURL("image/png");
//         img = img.replace('data:image/png;base64,', '');
//         var finalImageSrc = 'data:image/png;base64,' + img;
//         $('.map-shot').attr('src', finalImageSrc);
//     });
// }

$(function() {
	
	initMap();

    mapResize();

	//$('form.search-form').submit(findAddress);
    $( ".form-input--personalize" ).keyup(function() {
      findAddress();
    });
	$(window).on('resize', mapResize);

    map_obj.addListener("dragend", () => {
        updateMapShot(map_obj);
        // showMarker(map_obj.center);
    });

    map_obj.addListener("center_changed", () => {
        showMarker(map_obj.center);
    });

    map_obj.addListener("zoom_changed", () => {
        updateMapShot(map_obj);
    });

});